import React,{useEffect,useState, useRef } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import SlectInputField from "../SlectInputField";
import { Container, Row, Col, Tab, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import { Space, Table } from 'antd';
import Loader from '../Common/loader';
import {BASE_URL} from '../../lib/constant';
import "./MyWishlist.styles.css";

const wishlistColumns = [
  {
    title: 'Product',
    dataIndex: 'imageurl',
    key: 'imageurl',
    render: (_, record) => 
      <Link to={"/product-detail?matnum="+record.matnum}>
      <img src={AuthVerify.getImageLink(record.imageurl)} alt="Product" /></Link>,
  },
  {
    title: 'Description',
    key: 'matname',
    render: (_, record) => (
      <>
      <p className="product-name">
          <Link to={"/product-detail?matnum="+record.matnum}>{record.matname}</Link>
      </p>
      <small className="cart_ref">Matnum: {record.matnum}</small><br />
    </>
    )
  }
];

const MyWishlist = () => {
  const navigate = useNavigate();
  const [wishlist, setWishlist] = useState(false);

  useEffect(async () => {
      //Get my wishlist
      // /api/account/wishlist
      await Axios.get(`/account/wishlist`)
      .then(async (data) => {
        if(data.data?.data?.wishlist){
          setWishlist(data.data?.data?.wishlist);
        }
        else{
          setWishlist([])
        }
      });
  }, [])

  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>My Wishlist</h2>
          {/* <p>Loremn osum doky sit conseete,tut ugiscirq elit. Maecenas quis ex elei'end enim eget. eleifeod gwus. Oonec quis condenentum fin bus
                  </p> */}
        </div>
        <hr/>
        <div className="dashboard">
          <div className="box-account" style={{ display: "grid" }}>
            <div className="header-nav-dropdown-wrapper">
            {wishlist ? <>
              <Col sm={12} style={{padding:"0px"}}>
                <Col sm={3} style={{padding:"0px"}}>
                  <input type="text" placeholder="Search..." style={{marginRight: "0px",padding:"4px"}} />
                  <button type="button" style={{ padding:"5px 10px", borderRadius:"3px"}}>
                      <span className="glyphicon glyphicon-search"></span>
                  </button>
                </Col>
                <Col sm={5} style={{padding:"0px"}}>
                  
                </Col>
                <Col sm={2} style={{padding:"0px"}}>
                      {/* <SlectInputField
                        Name="country"
                        placeHolder="Select Your Country"
                        options={[]}
                        value={''}
                      /> */}
                </Col>
                <Col sm={2} style={{padding:"0px"}}>
                  {/* <input type="text" placeholder="Search..." style={{marginRight: "0px",padding:"4px"}} />
                  <button type="button" style={{ padding:"5px 10px", borderRadius:"3px"}}>
                      <span className="glyphicon glyphicon-search"></span>
                  </button> */}
                </Col>
              </Col>
              <br/>
              <br/>
              <Table locale={{ emptyText: 'No Budget Found !' }} className="osya table table-bordered jtv-cart-summary" style={{marginTop:"20px"}} columns={wishlistColumns} dataSource={wishlist} pagination={wishlist.length>10} />
              </>:<Loader/>
            }
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
};

export default MyWishlist;
